/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShapeComparisonMatch = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        team1: {
            type: 'TeamSmall',
            isRequired: true,
        },
        team2: {
            type: 'TeamSmall',
            isRequired: true,
        },
        goal1: {
            type: 'number',
            isRequired: true,
        },
        goal2: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
